import React, { Component } from 'react';

import {} from '../App.css';

class TechnicalHome extends Component {
    constructor(props) {
        super(props);
        document.title = "g-C3N4 General Information";
        this.state = {
            loaded: false
        };
        
        this.state = {
            loaded: true
        };
    
    }
    render() {
        if (this.state.loaded) {
            return (
                <div className="container">
                    <p className="title">General Information </p>
                    <p>Due to their properties (primarily large, tuneable band gaps and efficient intercalation of salts) graphitic carbon nitrides are under research for a variety of applications:</p>
                    <p className="subtitle">Photocatalysts</p>
                    <p>Decompostion of water to H2 and O2</p>
                    <p>Degradation of pollutants</p>
                    <p className="subtitle">Large band gap semiconductor</p>
                    <p>2.66 eV in pure g-C3N4</p>
                    <p className="subtitle">Heterogeneous catalyst and support</p>
                    <p>The significant resilience of carbon nitrides combined with surface and intralayer reactivities make them potentially useful catalysts relying on their labile protons and Lewis base functionalities. Modifications such as doping, protonation and molecular functionalisation can be exploited to improve selectivity and performance.</p>
                    <p>Nanoparticle catalysts supported on gCN are under development for both proton exchange membrane fuel cells and water electrolyzers.</p>
                    <p className="subtitle">Energy Storage materials</p>
                    <p>Due to the intercalation of Li being able to occur to more sites than for graphite due to intra layer voids in addition to intercalation between layers, gCN can store a large amount of Li making them potentially useful for rechargeable batteries.</p>         
                    <a className="small" rel="noopener noreferrer" target="_blank" href="https://en.wikipedia.org/wiki/Graphitic_carbon_nitride#Areas_of_interest">Reference: Wikipedia</a>
                </div>
            );
        } else {
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

export default TechnicalHome;


// WEBPACK FOOTER //
// ./src/Technical/TechnicalHome.js